<div class="ui-modal-overlay" [style.display]="(visible && backdrop) ? 'block' : 'none'"></div>


<div class="ui-modal" tabindex="-1" role="dialog"
     #modalRoot
     appDraggable
     [dragEventTarget]="dragEventTarget"
     [inViewport]="inViewport"
     [style.display]="validation ? 'block' : 'none'"
     (mousedown)="moveOnTop()"
     (touchstart)="moveOnTop()">
    <div class="ui-modal-header" #modalHeader
         (mousedown)="initDrag($event)"
         (touchstart)="initDrag($event)">
      <div class="ui-titlebar">
          <ng-content select=".app-modal-header"></ng-content>
      </div>
      <div class="ui-controlbar">
          <i class="ui-icon"
             *ngIf="maximizable"
             (click)="toggleMaximize($event)"
             [ngClass]="{'dt-icon-maximize': !maximized, 'dt-icon-normalize': maximized}">
          </i>
          <i class="ui-icon dt-icon-close" #closeIcon (click)="hide()">
          </i>
      </div>
    </div>
    <div class="line"></div>

    <div class="ui-modal-body" #modalBody>
      <ng-content select=".app-modal-body"></ng-content>
    </div>
    <div class="ui-modal-footer" #modalFooter>
      <ng-content select=".app-modal-footer"></ng-content>
    </div>
</div>

